import { render, staticRenderFns } from "./AgentInfo.vue?vue&type=template&id=31f2c9bc&scoped=true"
import script from "./AgentInfo.vue?vue&type=script&lang=js"
export * from "./AgentInfo.vue?vue&type=script&lang=js"
import style0 from "./AgentInfo.vue?vue&type=style&index=0&id=31f2c9bc&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f2c9bc",
  null
  
)

export default component.exports
import QSpinnerDots from 'quasar/src/components/spinner/QSpinnerDots.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QBadge from 'quasar/src/components/badge/QBadge.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QSpinnerDots,QIcon,QTooltip,QBadge});
